import {
  CheckCircle2,
  Info,
  ArrowDownToLine,
  ArrowUpFromLine,
} from "lucide-react";

export const typeConfig = {
  SUCCESS: {
    icon: CheckCircle2,
    color: "text-emerald-500",
    bg: "bg-emerald-50",
    badge: "bg-emerald-100 text-emerald-800",
    labelKey: "successful",
  },
  WITHDRAWAL: {
    icon: ArrowUpFromLine,
    color: "text-blue-500",
    bg: "bg-blue-50",
    badge: "bg-blue-100 text-blue-800",
    labelKey: "withdrawal",
  },
  DEPOSIT: {
    icon: ArrowDownToLine,
    color: "text-emerald-500",
    bg: "bg-emerald-50",
    badge: "bg-emerald-100 text-emerald-800",
    labelKey: "deposit",
  },
  SYSTEM: {
    icon: Info,
    color: "text-slate-500",
    bg: "bg-slate-50",
    badge: "bg-slate-100 text-slate-800",
    labelKey: "systemNotification",
  },
};

export const getTranslatedNotification = (notification = {}, t) => {
  const titleMap = {
    "New Withdrawal": t("newWithdrawalNotification") || "New Withdrawal",
    "New Deposit": t("newDepositNotification") || "New Deposit",
    Welcome: t("welcome") || "Welcome",
    "Withdrawal Requested":
      t("withdrawalRequested") || "Withdrawal Requested",
    "Withdrawal Success": t("withdrawalSuccess") || "Withdrawal Success",
    "Deposit Success": t("depositSuccess") || "Deposit Success",
  };

  const messageRules = [
    {
      pattern: /^(.+?)\s+requested a withdrawal of (\w+)\s+([\d,.]+)\.?$/i,
      buildMessage: ([, merchant, currency, amount]) =>
        `${merchant} ${
          t("requestedWithdrawal") || "requested a withdrawal of"
        } ${currency} ${amount}`,
    },
    {
      pattern: /^(.+?)\s+received a deposit of (\w+)\s+([\d,.]+)\.?$/i,
      buildMessage: ([, merchant, currency, amount]) =>
        `${merchant} ${
          t("receivedDeposit") || "received a deposit of"
        } ${currency} ${amount}`,
    },
    {
      pattern: /^welcome back,\s*(.+?)\s*!?$/i,
      buildMessage: ([, merchantName]) =>
        `${t("welcomeBack") || "Welcome back"}, ${merchantName}!`,
    },
    {
      pattern:
        /^your withdrawal request of\s+(\w+)\s+([\d,.]+)\s+has been received and is pending review\.?$/i,
      buildMessage: ([, currency, amount]) =>
        `${t("yourWithdrawalRequestOf") || "Your withdrawal request of"} ${currency} ${amount} ${
          t("hasBeenReceivedPendingReview") ||
          "has been received and is pending review."
        }`,
    },
  ];

  const message = String(notification.message || "");
  const matchedRule = messageRules.find(({ pattern }) =>
    pattern.test(message),
  );

  return {
    ...notification,
    title: titleMap[notification.title] || notification.title,
    message: matchedRule
      ? matchedRule.buildMessage(message.match(matchedRule.pattern))
      : notification.message,
  };
};
